module.exports = __webpack_public_path__ + "img/foreigner_women.27f5c789.png";